export interface UserLabelFormState {
    label: string | null;
    isActive: boolean;
    users: number[];
}
